import { createFileRoute, useSearch } from '@tanstack/react-router';
import { UpdatePileFormGql } from '@amber-ui/core';

function PileSettingsRoute() {
  const { pile } = useSearch({ strict: false }) as { pile?: string };
  const pile_id = pile || null;

  if (!pile_id) return null;

  return <UpdatePileFormGql pile_id={pile_id} />;
}

export const Route = createFileRoute('/_auth/_pile/pile/settings')({
  component: PileSettingsRoute,
});
